export default "__VITE_ASSET__DHKG8$SM__"